export default "__VITE_ASSET__DB1lRms0__"